import { useRef } from 'react';

const getDownColAndRowIndex = (matrix, colIndex, rowIndex) => {
  let nextColIndex = colIndex;
  let nextRowIndex = rowIndex + 1;
  if (nextRowIndex >= matrix[colIndex].length) {
    nextColIndex += 1;
    nextRowIndex = 0;
  }
  if (nextColIndex >= matrix.length) {
    nextColIndex = 0;
    nextRowIndex = 0;
  }

  return {
    colIndex: nextColIndex,
    rowIndex: nextRowIndex,
  };
};

const getUpColAndRowIndex = (matrix, colIndex, rowIndex) => {
  let nextColIndex = colIndex;
  let nextRowIndex = rowIndex - 1;
  if (nextRowIndex < 0) {
    nextColIndex -= 1;
    if (nextColIndex < 0) {
      nextColIndex = matrix.length - 1;
    }
    nextRowIndex = matrix[nextColIndex].length - 1;
  }

  return {
    colIndex: nextColIndex,
    rowIndex: nextRowIndex,
  };
};

const getLeftColAndRowIndex = (matrix, colIndex, rowIndex) => {
  let nextColIndex = colIndex - 1;
  let nextRowIndex = rowIndex;
  if (nextColIndex < 0) {
    nextColIndex = matrix.length - 1;
  }
  if (nextRowIndex >= matrix[nextColIndex].length) {
    nextRowIndex = matrix[nextColIndex].length - 1;
  }

  return {
    colIndex: nextColIndex,
    rowIndex: nextRowIndex,
  };
};

const getRightColAndRowIndex = (matrix, colIndex, rowIndex) => {
  let nextColIndex = colIndex + 1;
  let nextRowIndex = rowIndex;
  if (nextColIndex >= matrix.length) {
    nextColIndex = 0;
  }
  if (nextRowIndex >= matrix[nextColIndex].length) {
    nextRowIndex = matrix[nextColIndex].length - 1;
  }

  return {
    colIndex: nextColIndex,
    rowIndex: nextRowIndex,
  };
};

const useAutocompleteFocusedItem = (completions) => {
  const itemRefs = useRef({});

  const setItemRef = (ref, colIndex, rowIndex) => {
    itemRefs.current[`${colIndex}-${rowIndex}`] = ref;
  };

  const setFocus = (type, colIndex = undefined, rowIndex = undefined) => {
    if (!completions || completions.length === 0) return;

    const completionsMatrix = completions.map(({ items }) => [...items]);
    let nextColAndRowIndex = {
      colIndex: 0,
      rowIndex: 0,
    };
    if (colIndex !== undefined && rowIndex !== undefined) {
      if (type === 'down') {
        nextColAndRowIndex = {
          ...getDownColAndRowIndex(completionsMatrix, colIndex, rowIndex),
        };
      }
      if (type === 'up') {
        nextColAndRowIndex = {
          ...getUpColAndRowIndex(completionsMatrix, colIndex, rowIndex),
        };
      }
      if (type === 'left') {
        nextColAndRowIndex = {
          ...getLeftColAndRowIndex(completionsMatrix, colIndex, rowIndex),
        };
      }
      if (type === 'right') {
        nextColAndRowIndex = {
          ...getRightColAndRowIndex(completionsMatrix, colIndex, rowIndex),
        };
      }
    }

    if (
      itemRefs.current[
        `${nextColAndRowIndex.colIndex}-${nextColAndRowIndex.rowIndex}`
      ] !== undefined
    ) {
      itemRefs.current[
        `${nextColAndRowIndex.colIndex}-${nextColAndRowIndex.rowIndex}`
      ].focus();
    }
  };

  return {
    setItemRef,
    setFocus,
  };
};

export default useAutocompleteFocusedItem;
